import { ArchiveMutation } from "../../hooks/useArchiveState";
import { PatientVitalControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchiveVital = () =>
    useMutationWithLoading(
      async (param: ArchiveMutation) =>
        new PatientVitalControllerApi(
          getConfigObject()
        ).updateArchiveStatus1(
          param.id,
          param.status,
          param.xTENANTID //xTENANTID
        )
    );
  